export default {
    prompt: {
        delete: {
            title: 'Delete Account',
            description:
                'Are you sure you want to permanently delete this account?',
            confirmButton: 'delete',
            declineButton: 'cancel'
        },
        stopSession: {
            title: 'Stop Session',
            description: 'Are you sure you want to atop session?',
            confirmButton: 'stop',
            declineButton: 'cancel'
        },
        deleteCard: {
            title: 'Delete Card',
            description:
                'Are you sure you want to permanently delete your card?',
            confirmButton: 'Confirm',
            declineButton: 'Close'
        },
        cancelSubscription: {
            title: 'Cancel subscription',
            description: 'Are you sure you want to cancel your subscription?',
            confirmButton: 'Confirm',
            declineButton: 'Close'
        },
        reset: {
            title: 'Reset Password',
            description:
                'Are you sure you want to reset password for this account?',
            confirmButton: 'reset',
            declineButton: 'cancel'
        },
        deleteSession: {
            title: 'Delete Meditation',
            description:
                'Are you sure you want to permanently delete this meditation?',
            confirmButton: 'delete',
            declineButton: 'cancel'
        },
        deleteLandingPage: {
            title: 'Delete Landing Page',
            description:
                'Are you sure you want to permanently delete this Landing Page?',
            confirmButton: 'delete',
            declineButton: 'cancel'
        },
        video: {
            introduction: true,
            width: 1024
        }
    }
};
